export enum JobApplicationState {
	APPLICATION_REVIEW = 'application_review',
	INTERESTED = 'interested',
	TO_INTERVIEW = 'toInterview',
	OFFER = 'offer',
	HIRED = 'hired',
	REJECTED = 'rejected'
}

export enum JobApplicationReviewState {
	REVIEWING = 'reviewing',
	PASSED = 'passed',
	REJECTED = 'rejected'
}

export enum JobApplicationAssessmentState {
	PENDING = 'pending',
	REVIEWING = 'reviewing',
	PASSED = 'passed',
	FAILED = 'failed',
	MISSED = 'missed'
}

export enum JobApplicationCompanyReviewState {
	REVIEWING = 'reviewing',
	PASSED = 'passed',
	FAILED = 'failed'
}

export enum JobApplicationInterviewState {
	WAITING = 'waiting',
	SCHEDULED = 'scheduled',
	PASSED = 'passed',
	FAILED = 'failed',
	MISSED = 'missed'
}

export enum JobApplicationOfferState {
	PENDING = 'pending',
	ACCEPTED = 'accepted',
	WITHDRAWN = 'withdrawn',
	APPLICANT_COUNTERED = 'applicant_countered',
	EMPLOYER_COUNTERED = 'employer_countered',
	APPLICANT_REJECTED = 'applicant_rejected',
	EMPLOYER_REJECTED = 'employer_rejected',
	BACK_OFFICE_REJECTED = 'back_office_rejected'
}

export enum JobApplicationStep {
	APPLICATION_REVIEW = 'application_review',
	ASSESSMENT = 'assessment',
	COMPANY_REVIEW = 'company_review',
	INTERVIEW = 'interview',
	OFFER = 'offer'
}

export interface JobApplicationStepStatus {
	application_review: JobApplicationReviewState;
	assessment?: JobApplicationAssessmentState;
	company_review?: JobApplicationCompanyReviewState;
	interview?: JobApplicationInterviewState;
	offer?: JobApplicationOfferState;
}

export const StepPriority = {
	application_review: 0,
	assessment: 10,
	company_review: 20,
	interview: 30,
	offer: 40
};
